import wretch from 'wretch';

import { API_BASE_PATHS } from 'portal/src/api/constants';

const API_URL = import.meta.env.VITE_API_URL;

export const generateWelcomeOrResetPasswordUrl = async (body: any) =>
  await wretch(
    `${API_URL}${API_BASE_PATHS.AUTH.GENERATE_WELCOME_OR_RESET_PASSWORD_URL}`,
  )
    .options({ credentials: 'include' })
    .json(body)
    .post()
    .badRequest((err) => {
      throw err['json'];
    })
    .res();

export const forgotPasswordService = async (body: any, useWorkos = false) =>
  await wretch(
    `${API_URL}${
      useWorkos
        ? API_BASE_PATHS.AUTH.WORKOS_FORGOT_PASSWORD
        : API_BASE_PATHS.AUTH.FORGOT_PASSWORD
    }`,
  )
    .options({ credentials: 'include' })
    .json(body)
    .post()
    .badRequest((err) => {
      throw err['json'];
    })
    .res();
